var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCassette(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 54,
    viewBox: "0 0 26 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 50,
    rx: 7,
    stroke: "#00A3B8",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 13.5,
    width: 7,
    height: 18,
    rx: 2.5,
    stroke: "#00A3B8",
    strokeWidth: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 37.5,
    width: 7,
    height: 8,
    rx: 2.5,
    stroke: "#00A3B8",
    strokeWidth: 3
  })));
}

export default SvgCassette;